import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { GlobalConstants } from '../../common/global-variable';
import { ApiService } from '../../service/api.service';
import { ImageProcessComponent } from './image-process/image-process.component';
import { NgxIndexedDBService } from 'ngx-indexed-db';
@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {
  firstname
  lastname
  birthplace
  birthyear
  birthmonth
  birthday
  deathplace
  deathyear
  deathmonth
  deathday
  marriageplace
  marriageyear
  marriagemonth
  marriageday

  depth
  avatar_allow = true;
  birth_allow = true;
  death_allow = true;
  marriage_allow = true;

  flag_type = "origin"
  flag_image = ""
  country_allow = true;

  country_list = ['Sweden', 'Denmark', 'Finland', 'France', 'Germany', 'Italy', 'Norway', 'Paraguay', 'Switzerland', 'UK', 'US', 'Luxembourg', 'Liechtenstein', 'Latvia', 'Hungary', 'Greece', 'Croatia', 'Canada', 'Bulgaria', 'Belgium', 'Austria', 'Australia', 'Argentina', 'Ukraine', 'Netherlands', 'Czech Republic', 'Spain', 'Slovenia', 'Slovakia', 'Serbia', 'Portugal', 'Poland', 'New Zealand'].sort()
  country = ''

  avatar_change = false
  avatar_setting = "SHOW"

  note = ""
  imgURL

  maleAvatar = [GlobalConstants.male_1, GlobalConstants.male_2, GlobalConstants.male_3, GlobalConstants.male_4,
    GlobalConstants.male_5, GlobalConstants.male_6, GlobalConstants.male_7, GlobalConstants.male_8, GlobalConstants.male_9,
    GlobalConstants.male_10, GlobalConstants.male_11, GlobalConstants.male_12];
    
  femaleAvatar = [GlobalConstants.female_1, GlobalConstants.female_2, GlobalConstants.female_3, GlobalConstants.female_4,
    GlobalConstants.female_5, GlobalConstants.female_6, GlobalConstants.female_7, GlobalConstants.female_8, GlobalConstants.female_9,
    GlobalConstants.female_10, GlobalConstants.female_11, GlobalConstants.female_12];
    

  constructor(
    public matDialog: MatDialog,
    public dialogRef: MatDialogRef<ModalComponent>,
    private dbService: NgxIndexedDBService,
    @Inject(MAT_DIALOG_DATA) public modalData: any,
    private ApiService: ApiService,
  ) {
  }

  ngOnInit() {
    this.country_list.splice(0, 0, 'NoFlag');
    this.country_list.join();
    console.log('Node Info: ', this.modalData);

    this.avatar_setting = this.modalData.avatar_setting ? this.modalData.avatar_setting : "SHOW"
    if (this.modalData.avatar_type == "sample" && typeof this.modalData.url == 'number') {
      if (this.modalData.sex == "M") {
        this.imgURL = this.maleAvatar[parseInt(this.modalData.url)]
      } else {
        this.imgURL = this.femaleAvatar[parseInt(this.modalData.url)]
      }
    } else {
      this.imgURL = this.modalData.url
    }

    let nodeinfos;
    this.dbService.getByKey('nodes', 1).subscribe((nodes: any) => {
      nodeinfos = JSON.parse(nodes.nodeinfos)
      this.note = nodeinfos[this.modalData.id] ? nodeinfos[this.modalData.id].note : ''

      this.firstname = this.modalData.firstName ? this.modalData.firstName : "n/a"
      this.lastname = this.modalData.lastName ? this.modalData.lastName : "n/a"
      this.country = this.modalData.country
      this.birthplace = this.modalData.birth && this.modalData.birth.place ? this.modalData.birth.place : "n/a"
      this.birthyear = this.modalData.birth && this.modalData.birth.date && this.modalData.birth.date.year ? this.modalData.birth.date.year : "-"
      this.birthmonth = this.modalData.birth && this.modalData.birth.date && this.modalData.birth.date.month ? this.modalData.birth.date.month : "-"
      this.birthday = this.modalData.birth && this.modalData.birth.date && this.modalData.birth.date.day ? this.modalData.birth.date.day : "-"
      this.deathplace = this.modalData.death && this.modalData.death.place ? this.modalData.death.place : "n/a"
      this.deathyear = this.modalData.death && this.modalData.death.date && this.modalData.death.date.year ? this.modalData.death.date.year : "-"
      this.deathmonth = this.modalData.death && this.modalData.death.date && this.modalData.death.date.month ? this.modalData.death.date.month : "-"
      this.deathday = this.modalData.death && this.modalData.death.date && this.modalData.death.date.day ? this.modalData.death.date.day : "-"

      let c_fam = this.modalData.c_fam;
      if (c_fam) {
        this.marriageplace = this.modalData.marriage && this.modalData.marriage[c_fam] && this.modalData.marriage[c_fam].place ? this.modalData.marriage[c_fam].place : "n/a";
        this.marriageyear = this.modalData.marriage && this.modalData.marriage[c_fam] && this.modalData.marriage[c_fam].date && this.modalData.marriage[c_fam].date.year ? this.modalData.marriage[c_fam].date.year : "-"
        this.marriagemonth = this.modalData.marriage && this.modalData.marriage[c_fam] && this.modalData.marriage[c_fam].date && this.modalData.marriage[c_fam].date.month ? this.modalData.marriage[c_fam].date.month : "-"
        this.marriageday = this.modalData.marriage && this.modalData.marriage[c_fam] && this.modalData.marriage[c_fam].date && this.modalData.marriage[c_fam].date.day ? this.modalData.marriage[c_fam].date.day : "-"
      }
      this.depth = this.modalData.depth

      if (this.depth > 5) {
        this.avatar_allow = false
        this.country_allow = false
      }
      if (this.depth > 8) this.birth_allow = false, this.death_allow = false;
      if (this.depth == 0 || this.depth > 6) this.marriage_allow = false;
    }, err => console.log(err));
  }

  imageProcess() {
    const dialogConfig = new MatDialogConfig();
    // The user can't close the dialog by clicking outside its body
    dialogConfig.disableClose = true;
    dialogConfig.id = "image-process-component";
    dialogConfig.maxHeight = '90vh';
    dialogConfig.data = {
      type: 'node-avatar'
    }
    const modalDialog = this.matDialog.open(ImageProcessComponent, dialogConfig);
    modalDialog.afterClosed().subscribe((result) => {
      if (result) {
        this.imgURL = result;
        (document.querySelector('#imagePreview3') as HTMLElement).style.backgroundImage = 'url(' + result + ')';
      }
    });
  }

  selectCountry(value) {
    this.country = value;
  }

  actionFunction() {
    let nodeinfos;
    this.dbService.getByKey('nodes', 1).subscribe((nodes: any) => {
      nodeinfos = JSON.parse(nodes.nodeinfos)
   
      let gedcom_id = localStorage.getItem('gedcom_id');
      let currentNode = nodeinfos[this.modalData.id] ? nodeinfos[this.modalData.id] : GlobalConstants.node_structure;
      currentNode.id = this.modalData.id;
      currentNode.url = this.imgURL;
      currentNode.avatar_type = this.avatar_change ? 'updated' : "sample";

      currentNode.c_fam = this.modalData.c_fam;
      currentNode.marriage = this.modalData.marriage;
      currentNode.sex = this.modalData.sex;

      currentNode.firstName = this.firstname;
      currentNode.lastName = this.lastname;
      currentNode.country = this.country;
      if (this.flag_type == 'custom') {
        currentNode.country = 'custom';
      }
      currentNode.c_flag = this.flag_image;
      currentNode.avatar_setting = this.avatar_setting;
      currentNode.note = this.note;

      currentNode.birthday = this.birthyear + "." + this.birthmonth + "." + this.birthday;
      currentNode.birth = currentNode.birth ? currentNode.birth : {};
      currentNode.birth.date = currentNode.birth.date ? currentNode.birth.date : {};
      currentNode.birth.place = this.birthplace;
      currentNode.birth.date.year = this.birthyear;
      currentNode.birth.date.month = this.birthmonth;
      currentNode.birth.date.day = this.birthday;

      currentNode.deathday = this.deathyear + "." + this.deathmonth + "." + this.deathday;
      currentNode.death = currentNode.death ? currentNode.death : {};
      currentNode.death.date = currentNode.death.date ? currentNode.death.date : {};
      currentNode.death.place = this.deathplace;
      currentNode.death.date.year = this.deathyear;
      currentNode.death.date.month = this.deathmonth;
      currentNode.death.date.day = this.deathday;

      let c_fam = this.modalData.c_fam;
      if (c_fam) {
        currentNode.marriage[c_fam] = currentNode.marriage[c_fam] ? currentNode.marriage[c_fam] : {};
        currentNode.marriage[c_fam].date = currentNode.marriage[c_fam].date ? currentNode.marriage[c_fam].date : {};
        currentNode.marriage[c_fam].place = this.marriageplace;
        currentNode.marriage[c_fam].date.year = this.marriageyear;
        currentNode.marriage[c_fam].date.month = this.marriagemonth;
        currentNode.marriage[c_fam].date.day = this.marriageday;
      }
      currentNode.gedcom_id = gedcom_id;
      nodeinfos[this.modalData.id] = currentNode;
      console.log(currentNode)

      this.ApiService.updateNode(currentNode)
        .then((data: any) => {
          this.dialogRef.close(true);
        })
    }, err => console.log(err));
  }

  closeModal() {
    this.dialogRef.close();
  }

  profileSetting(value) {


    this.avatar_setting = value;
  }

  resetNodeImage(){
    let imageNr = Math.floor(Math.random() * 12);
    console.log(imageNr)
    if (this.modalData.sex == "M") {
      this.imgURL = this.maleAvatar[imageNr]
    } else {
      this.imgURL = this.femaleAvatar[imageNr]
    }
    this.avatar_change = false;
  }

  setFlag($event) {
    var files = $event.target.files;

    var reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      var img = new Image();
      img.src = reader.result.toString();
      img.onload = () => {
        this.flag_image = reader.result.toString();


      }
    }

  }

}